import {createRouter, createWebHistory} from "vue-router"
import {RoutesEnum} from "@/router/types"
import {useAuthStore} from "@/stores/auth"
//@ts-ignore
import transport from "@/net/transport.js"
import {UserRoles} from "@/stores/auth/types"
import * as Sentry from "@sentry/vue"
import {usePageStore} from "@/stores/page"

const EXPZ_ADMIN_DOMAIN = import.meta.env.VITE_EXPZ_ADMIN_DOMAIN + "/auth"

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: RoutesEnum.StartPage,
      name: "home",
      meta: {
        requiredAuth: true,
        allowedRoles: [UserRoles.adminEditor, UserRoles.guestAnalytics, UserRoles.crmProfileView],
      },
      component: () => import("../pages/Home.vue"),
    },
    {
      path: RoutesEnum.DashboardPage,
      name: "dashboard",
      meta: {
        requiredAuth: true,
        allowedRoles: [UserRoles.adminEditor, UserRoles.guestAnalytics, UserRoles.crmProfileView],
      },
      props: (route) => ({
        restaurantId: route.query.id,
      }),
      component: () => import("../pages/DashboardPage/Page.vue"),
    },
    {
      path: RoutesEnum.UserLogin,
      name: "login",

      props: (route) => ({
        referUrl: route.redirectedFrom?.fullPath,
      }),
      beforeEnter(to, from) {
        // console.log(from)
        // console.log(to)
        // console.log("from", window.location)

        // redirect to external link
        console.log("from", window.location)

        const referUrl = to.redirectedFrom?.fullPath || from.fullPath
        const url = new URL(EXPZ_ADMIN_DOMAIN)
        url.searchParams.append("source", "CRM")
        url.searchParams.append("subSystemBrowserId", localStorage.publickBrowserId)
        url.searchParams.append("redirectUrl", window.location.origin + "/callback")
        if (referUrl) {
          url.searchParams.append("referUrl", `${referUrl}`)
        }
        console.log("URL", url)
        // @ts-ignore
        window.location.href = url
      },
      component: () => import("../pages/LoginPage.vue"),
    },
    {
      path: RoutesEnum.GuestListPage,
      children: [
        {
          path: "",
          name: "profile-list",
          meta: {
            requiredAuth: true,
          },
          props: (route) => ({
            restaurantId: route.query.restaurant_id,
            orderBy: route.query.order_by,
            order: route.query.order,
            currentPage: route.query.page,
            itemsPerPage: route.query.size,
            segmentIds: route.query.segments,
            dateFrom: route.query.from,
          }),
          component: () => import("../pages/GuestListPage/Page.vue"),
        },
        {
          path: RoutesEnum.GuestProfilePage,
          name: "profile",
          meta: {
            requiredAuth: true,
          },
          props: (route) => ({
            profileId: route.params.profileId,
            networkProfileId: route.query.networkProfileId,
          }),
          component: () => import("../pages/GuestProfile/GuestProfilePage.vue"),
        },
      ],
    },
    {
      path: RoutesEnum.OffersPage,
      name: "offers",
      meta: {
        requiredAuth: true,
        allowedRoles: [UserRoles.restaurantAdmin, UserRoles.adminEditor, UserRoles.guestAnalytics],
      },
      props: (route) => ({
        restaurantId: route.query.id,
      }),
      component: () => import("../pages/Offers/OffersPage.vue"),
    },
    {
      path: RoutesEnum.UIKitPage,
      name: "ui-kit",
      component: () => import("../pages/UIKitPage.vue"),
    },
    // {
    //   path: RoutesEnum.CallBack,
    //   name: "callback",
    //   component: () => import("../pages/UIKitPage.vue"),
    // },
    {
      path: "/404",
      name: "not-found",
      component: () => import("../pages/404Page.vue"),
    },
    {
      path: RoutesEnum.Status403Page,
      name: "no-access",
      component: () => import("../pages/403Page.vue"),
    },
    {
      path: RoutesEnum.NotFound,
      name: "not-found",
      component: () => import("../pages/404Page.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {top: 0}
    }
  },
})

router.beforeEach(async (to, from, next) => {
  await transport.update()

  const authStore = useAuthStore()

  if (to.path === RoutesEnum.CallBack && to.query.token) {
    console.log("HAVE REFERER", to.query?.referUrl)
    await authStore.login(to.query.token as string)
    to.query?.referUrl ? next(`${to.query.referUrl}`) : next("/")
  }

  if (to.meta.requiredAuth) {
    if (authStore.isLoggedIn) {
      // User is authenticated, proceed to the route
      next()
    }
    // User is not authenticated, redirect to login
    else next(RoutesEnum.UserLogin)
  }
  // Non-protected route, allow access
  else {
    console.log("Don't required auth")
    next()
  }
})

router.afterEach((to, from, failure) => {
  if (failure && failure.message?.startsWith("voided redundant navigation to current location")) {
    Sentry.captureException(
      `Failed navigate from ${JSON.stringify(from)} to ${JSON.stringify(to)}. Reason: ${failure}`
    )
  }
})

router.beforeResolve(() => {
  const pageStore = usePageStore()
  if (pageStore.sidebarVisible) {
    pageStore.$patch({
      sidebarVisible: false,
    })
  }
})

// router.afterEach(async (to) => {
//   const authStore = useAuthStore()
//   const allowedRoles = to.meta?.allowedRoles

//   if (to.meta?.requiredAuth && allowedRoles && Array.isArray(allowedRoles)) {
//     const roles = await authStore.userRoles
//     if (!roles.some(role => allowedRoles.includes(role))) {
//       router.push(RoutesEnum.Status403Page)
//     }
//   }
// })

export default router
